export const asBoolean = (value: unknown, fallback = false): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    if (value.toLowerCase() === 'true') {
      return true;
    }
    if (value.toLowerCase() === 'false') {
      return false;
    }
  }
  // Some CMS/API boolean flags may arrive as numeric 1/0 values.
  if (typeof value === 'number') {
    return value !== 0;
  }
  return fallback;
};
